import React, { useState, useEffect } from 'react';
import ChartCard from './ChartCard';
import { fetchMarketBreadth } from '../services/api'; 
import BrokerLoginModal from './BrokerLoginModal';
import '../styles/darkTheme.css';
import SessionModal from './SessionModal';
import ChartCard1 from './ChartCard copy.js';

const STATIC_INDEX_LIST = [
  "NIFTY BANK", "NIFTY AUTO", "NIFTY FINANCIAL SERVICES", "NIFTY FMCG",
  "NIFTY IT", "NIFTY MEDIA", "NIFTY METAL", "NIFTY PHARMA",
  "NIFTY PSU BANK", "NIFTY PRIVATE BANK", "NIFTY REALTY", "NIFTY HEALTHCARE INDEX",
  "NIFTY CONSUMER DURABLES", "NIFTY OIL & GAS", "NIFTY ENERGY", "NIFTY NEXT 50",
  "NIFTY INDIA DEFENCE", "NIFTY PSE", "NIFTY CAPITAL MARKETS","NIFTY 500","NIFTY MIDCAP SELECT",
];

const getTodayDateString = () => {
  return new Date().toISOString().split('T')[0];
};

const Dashboard = () => {
  const [selectedIndex, setSelectedIndex] = useState('NIFTY 500');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSessionModalOpen, setIsSessionModalOpen] = useState(false); 
  const [nscData, setNscData] = useState([]);
  const [nscAdv, setNscAdv] = useState(0);
  const [nscDec, setnscDec] = useState(0);
  const [nscNotcha, setnscNotcha] = useState(0);
  const [breadthData, setBreadthData] = useState({
    '5m': null, '15m': null, '60m': null, 'day': null, 'week': null, 'month': null
  }); //, 'week': null, 'month': null

  const [loading, setLoading] = useState({ 
    '5m': true, '15m': true, '60m': true, 'day': true, 'week': true, 'month': true 
  }); //, 'week': true, 'month': true 
  
  const [framesConfig, setFramesConfig] = useState({ 
    '5m': 100, '15m': 100, '60m': 100, 'day': 100, 'week': 100, 'month': 100 
  }); // , 'week': 100, 'month': 100 

  const [loadingTime, setLoadingTime] = useState({
    '5m': "0", '15m': "0", '60m': "0", 'day': "0", 'week': "0", 'month': "0"
  });  //, 'week': "0", 'month': "0"

  const [lastLoaded, setLastLoaded] = useState({
    '5m': null, '15m': null, '60m': null, 'day': null, 'week': null, 'month': null
  }); /// , 'week': null, 'month': null
  
  const [liveMarketData, setLiveMarketData] = useState({});


    //   { id: 'week', label: 'Weekly', table: 'week' },
    // { id: 'month', label: 'Monthly', table: 'month' }
  const timeframes = [
    { id: '5m', label: '5 Minutes', table: 'five_minute' },
    { id: '15m', label: '15 Minutes', table: 'fifteen_minute' },
    { id: '60m', label: '60 Minutes', table: 'one_hour' },
    { id: 'day', label: 'Daily', table: 'day' },
    { id: 'week', label: 'weekly', table: 'week' },
    { id: 'month', label: 'monthly', table: 'month' },
  ]; 


const fetchSingleChart = async (tfId, numFrames, forceRefresh = false) => {
    setLoading(prev => ({ ...prev, [tfId]: true }));
    try {
        const targetIndex = selectedIndex === 'NIFTY NEXT 50' ? 'NIFTY NEXT 50' : selectedIndex;
        const isStaticTimeframe = ['day', 'week', 'month'].includes(tfId);
        const now = Date.now();
        
        const cacheKey = `breadth_${targetIndex}_${tfId}_${numFrames}`;

        // --- 1. SMART CACHE ENGINE ---
        if (!forceRefresh) {
            const cachedString = localStorage.getItem(cacheKey);
            if (cachedString) {
                try {
                    const cachedPayload = JSON.parse(cachedString);
                    let isValidCache = false;

                    if (isStaticTimeframe) {
                        const cachedDate = new Date(cachedPayload.timestamp).toDateString();
                        const todayDate = new Date().toDateString();
                        if (cachedDate === todayDate) isValidCache = true;
                    } else {
                        let maxAgeMs = 15000; // fallback
                        if (tfId === '5m') maxAgeMs = 5 * 60 * 1000;
                        if (tfId === '15m') maxAgeMs = 15 * 60 * 1000;
                        if (tfId === '60m') maxAgeMs = 60 * 60 * 1000;

                        if (now - cachedPayload.timestamp < maxAgeMs) {
                            isValidCache = true;
                        }
                    }

                    if (isValidCache) {
                        console.log(`⚡ Loaded ${tfId} and NSC data natively from Cache`);
                        
                        // Update regular breadth chart data
                        setBreadthData(prev => ({ ...prev, [tfId]: cachedPayload.data || [] }));
                        
                        // 🔥 Update unified NSC global chart panel data from cache
                        if (tfId === '5m'){
                          setNscData(cachedPayload.nsedata || []);
                        }
                        
                        setFramesConfig(prev => ({ ...prev, [tfId]: numFrames })); 
                        setLoadingTime(prev => ({ ...prev, [tfId]: cachedPayload.total_time }));
                        
                        const timestamp = new Date(cachedPayload.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
                        setLastLoaded(prev => ({ ...prev, [tfId]: `${timestamp} (Cached)` }));
                        
                        setLoading(prev => ({ ...prev, [tfId]: false }));
                        return true;
                    }
                } catch (e) {
                    console.error("Corrupted cache data, fetching fresh.", e);
                    localStorage.removeItem(cacheKey);
                }
            }
        }

        // --- 2. FETCH FROM API ---
        // Expecting the root object structure returned from fetchMarketBreadth
        const apiResponse = await fetchMarketBreadth(tfId, numFrames, targetIndex);
        console.log(`Loaded ${tfId} data from API raw payload:`, apiResponse);
        
        // Extract array records safely from their distinct keys inside the root payload wrapper
        const actualDataArray = Array.isArray(apiResponse.data) ? apiResponse.data : [];
        const actualNscArray = Array.isArray(apiResponse.nsedata) ? apiResponse.nsedata : [];
        const actualTotalTime = apiResponse.total_time || "0";

        // --- 3. SAVE TO CACHE ---
        const payloadToCache = {
            timestamp: Date.now(), 
            data: actualDataArray,
            nsedata: actualNscArray, // 🔥 Cache the NSC advances array block too
            total_time: actualTotalTime
        };
        localStorage.setItem(cacheKey, JSON.stringify(payloadToCache));

        // --- 4. UPDATE UI ---
        setBreadthData(prev => ({ ...prev, [tfId]: actualDataArray }));
        
        // 🔥 Live-update your independent state variable for the NSC layout card block
        if(tfId === '5m'){
          setNscData(actualNscArray);
        }
        
        setFramesConfig(prev => ({ ...prev, [tfId]: numFrames })); 
        setLoadingTime(prev => ({ ...prev, [tfId]: actualTotalTime }));
        
        const timestampStr = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        setLastLoaded(prev => ({ ...prev, [tfId]: timestampStr }));
        return true;
    } catch (error) {
        console.error(`Error loading ${tfId} data vector chains:`, error);
        return false;
    } finally {
        setLoading(prev => ({ ...prev, [tfId]: false }));
    }
};


const fetchLiveAdvances = async () => {
    try {
      // NOTE: Read the architectural notice below regarding direct browser requests to NSE
      const response = await fetch('https://www.nseindia.com/api/live-analysis-advance');
      const json = await response.json();
      
      // Navigate down to the specific nested structure: data.advance.count
      const counts = json?.advance?.count;
      
      if (counts) {
        setNscAdv(counts.Advances || 0);
        setnscDec(counts.Declines || 0);
        setnscNotcha(counts.Unchange || 0);
        
        console.log("NSE Metrics Loaded:", counts);
      }
    } catch (error) {
      console.error("Error fetching native live analysis counters:", error);
    }
  };


const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  useEffect(() => {
      let isActive = true;

      const loadAllCharts = async (isRefresh = false) => {
        // --- LIVE FILTERING ---
        // First run (isRefresh = false): Load all 6 timeframes
        // Background interval (isRefresh = true): Filter and load ONLY up to 60m
        const activeTimeframes = isRefresh ? timeframes.filter(tf => ['5m', '15m', '60m','week','month'].includes(tf.id)) : timeframes;

        console.log(`Starting queue for ${selectedIndex}... (Refresh: ${isRefresh}, Total Charts: ${activeTimeframes.length})`);
        
        for (let i = 0; i < activeTimeframes.length; i++) {
          if (!isActive) break;
          const tf = activeTimeframes[i];
          
          // Pass the isRefresh flag down to bypass cache on interval updates
          const success = await fetchSingleChart(tf.id, framesConfig[tf.id], isRefresh);
          console.log(`loadAllCharts. success ${success} ${tf.id} ${framesConfig[tf.id]}.`);
          
          if (!success) {
            console.error(`Queue aborted. Server rejected request for ${tf.id}.`);
            break; 
          }

          // Maintain the 3-second breathing room between sequential requests
          if (i < activeTimeframes.length - 1) {
            await delay(3000); 
          }
        }
      };

      // 1. FIRST RUN: Reset loading screens and fetch ALL 6 charts
      setLoading({ '5m': true, '15m': true, '60m': true, 'day': true, 'week': true, 'month': true });
      loadAllCharts(false); 

      // 2. BACKGROUND INTERVAL MASTER CLOCK (Every 5 minutes)
      const intervalMs = 5 * 60 * 1000;
      const offsetMs = 20 * 1000; // 20-second buffer (e.g., 10:10:20)
      let timeoutId;
      let intervalId;

      const syncAndStart = () => {
        const now = Date.now();
        let targetEpoch = Math.floor(now / intervalMs) * intervalMs + offsetMs;
        
        if (targetEpoch <= now) {
          targetEpoch += intervalMs;
        }
        
        const msUntilNextTrigger = targetEpoch - now;
        const nextTime = new Date(targetEpoch).toLocaleTimeString();
        console.log(`[SYNC] Next background update (up to 60m) scheduled for exactly ${nextTime}`);

        timeoutId = setTimeout(() => {
          if (!isActive) return;
          
          // Trigger the queue with isRefresh = true (updates only 5m, 15m, 60m)
          loadAllCharts(true); 
          
          intervalId = setInterval(() => {
            if (isActive) loadAllCharts(true);
            // fetchLiveAdvances();
          }, intervalMs);

        }, msUntilNextTrigger);
      };

      syncAndStart();

      // Cleanup on index switch or component unmount
      return () => {
        isActive = false;
        clearTimeout(timeoutId);
        clearInterval(intervalId);
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIndex]);

  const liveTickers = Object.values(liveMarketData);
  const [showNotification, setShowNotification] = useState(true);

  return (
    <div className="dashboard">
      {showNotification && (
        <div className="notification-banner">
          <div className="notification-content">
            <span className="notification-icon">🔔</span>
            <p><strong>Market Update:</strong> </p>
          </div>
          <button className="close-notification" onClick={() => setShowNotification(false)} title="Dismiss">
            ✕
          </button>
        </div>
      )}
      <header className="dashboard-header">
        <h1>NextOrbitals Trading Intelligence</h1>
        
        <div className="stock-ticker-container">
          <div className="stock-ticker">
            {liveTickers.length > 0 ? (
              [...liveTickers, ...liveTickers].map((item, idx) => (
                <span key={idx} className="ticker-item">
                  <span className="ticker-symbol">{item.stock_name}</span>
                  <span className="ticker-price">
                    {item.last_traded_price ? `₹${(item.last_traded_price / 100).toFixed(2)}` : '...'}
                  </span>
                </span>
              ))
            ) : (
              <span className="ticker-item">live market data...</span>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '20px' }}>
          
          <div className="index-selector">
            <span style={{ color: '#b0b0b0', marginRight: '10px', fontWeight: 'bold' }}>Select Market:</span>
            <select 
              value={selectedIndex} 
              onChange={(e) => setSelectedIndex(e.target.value)}
              className="filter-select"
              style={{ padding: '10px', fontSize: '1rem', backgroundColor: '#2d2d2d', color: '#fff', border: '1px solid #404040', borderRadius: '6px' }}
            >
              <option value="NIFTY NEXT 50">NIFTY NEXT 50</option>
              {STATIC_INDEX_LIST.map((idxName) => (
                <option key={idxName} value={idxName}>
                  {idxName}
                </option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button 
              onClick={() => setIsSessionModalOpen(true)}
              style={{
                background: '#2d2d2d', border: '1px solid #404040', borderRadius: '50%',
                width: '40px', height: '40px', display: 'flex', justifyContent: 'center', 
                alignItems: 'center', cursor: 'pointer', color: '#b0b0b0', fontSize: '1.2rem'
              }}
              title="Schedule Special Session"
            >
              📅
            </button>

            <button 
              onClick={() => setIsModalOpen(true)}
              style={{
                background: '#2d2d2d', border: '1px solid #404040', borderRadius: '50%',
                width: '40px', height: '40px', display: 'flex', justifyContent: 'center', 
                alignItems: 'center', cursor: 'pointer', color: '#b0b0b0', fontSize: '1.2rem'
              }}
              title="Update Broker Credentials"
            >
              👤
            </button>
          </div>
        </div>

        <SessionModal isOpen={isSessionModalOpen} onClose={() => setIsSessionModalOpen(false)} />
        <BrokerLoginModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        
      </header>

      <div className="charts-grid" style={{ display: 'flex', flexDirection: 'column', gap: '30px', marginBottom: '40px' }}>
  
      {/* 🔥 SPECIAL CHART: Positioned at the very top of the layout */}
      <div className="chart-wrapper special-nsc-chart" style={{ borderBottom: '2px自动 #1a1a1a', paddingBottom: '10px' }}>
        {/* Using tfId '60m' (or any active default) as the driver for the load triggers */}
        {nscData.length === 0 ? (
          <div className="chart-loading">
            <div className="spinner-small"></div>
            <p>Loading NSE Global Analytics...</p>
          </div>
        ) : (
          <ChartCard1 
            loadingTime={loadingTime['5m']} 
            lastLoaded={lastLoaded['5m']}
            data={nscData} 
            timeframe="NSE (ADVANCES / DECLINES)" 
            currentFrames={100}
            onFetchFrames={(newFrames) => fetchSingleChart('', newFrames, true)}
            isNscChart={true} // Switches ChartCard to Green/Red/Gray Advances layout
            nscAdv = {nscAdv}
            nscDec = {nscDec}
            nscNotcha = {nscNotcha}
          />
        )}
      </div>

      {/* Visual Separator line between Special Chart and standard timeframes */}
      <hr style={{ border: '0', borderTop: '1px solid #111111', margin: '0' }} />

      {/* Standard Timeframe Candlestick Breadth Charts (Loop) */}
      {timeframes.map(tf => (
        <div key={tf.id} className="chart-wrapper">
          {loading[tf.id] ? (
            <div className="chart-loading">
              <div className="spinner-small"></div>
              <p>Loading {tf.label} data...</p>
            </div>
          ) : (
            <ChartCard 
              loadingTime={loadingTime[tf.id]}
              lastLoaded={lastLoaded[tf.id]}
              data={breadthData[tf.id]} 
              timeframe={tf.label} 
              currentFrames={framesConfig[tf.id]}
              onFetchFrames={(newFrames) => fetchSingleChart(tf.id, newFrames, true)}
            />
          )}
        </div>
      ))}
      
    </div>

      <footer className="dashboard-footer">
        <p>© 2026 NextOrbitals. All Rights Reserved.</p>
        <p className="disclaimer">
          Data provided by Angel One SmartAPI. For informational purposes only.
        </p>
      </footer>
    </div>
  );
};

export default Dashboard;